/* istanbul ignore file */
import React from 'react';
import useInputHelper from './inputHelper';
import { useUiTheme } from 'framework/uiTheme';
import {
  DefaultInputPropTypes,
  DefaultInputLayoutProps,
  InputLayoutHintProps,
  InputLayoutStateProps,
  ValidationLayoutProps,
} from './types';
import { FormFieldsData } from '../FormContext';

export type CheckboxGroupValue = string | number;

export type CheckboxButtonOption = {
  value: CheckboxGroupValue;
  label: string | JSX.Element;
};

interface CommonCheckboxGroupProps {
  options: CheckboxButtonOption[];
  isColumnDirection?: boolean;
  checkedValues?: CheckboxGroupValue[];
}

export interface CheckboxGroupProps extends CommonCheckboxGroupProps, DefaultInputPropTypes<CheckboxGroupValue[]> {}

export interface CheckboxGroupLayoutProps
  extends
    CommonCheckboxGroupProps,
    DefaultInputLayoutProps<CheckboxGroupValue[]>,
    InputLayoutHintProps,
    InputLayoutStateProps,
    ValidationLayoutProps {
  onChangeCallback?: Nullable<(values: FormFieldsData, isFieldInitializing?: boolean) => void>;
  onBlurCallback?: () => void;
  onFocusCallback?: () => void;
}

export type CheckboxGroupLayoutType = ReactComponent<CheckboxGroupLayoutProps>;

const CheckboxGroup = ({ isColumnDirection = false, ...props }: CheckboxGroupProps) => {
  const inputHelper = useInputHelper(props);
  const { CheckboxGroupLayout } = useUiTheme<CheckboxGroupLayoutType>();

  return (
    <CheckboxGroupLayout
      {...props}
      isVisible={inputHelper.isVisible()}
      disabled={inputHelper.getIsDisabled()}
      className={inputHelper.getClassName()}
      isColumnDirection={isColumnDirection}
      label={inputHelper.getLabel()}
      source={inputHelper.getSource()}
      onChangeCallback={inputHelper.getRawOnChangeCallback()}
      onBlurCallback={inputHelper.getValidationCallback()}
      onFocusCallback={inputHelper.getClearValidationCallback()}
      value={inputHelper.getValue()}
      isRequired={inputHelper.getIsRequired()}
      errorMessages={inputHelper.getErrorMessages()}
    />
  );
};

export default CheckboxGroup;
